import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {Application} from '../types';
import {ApplicationStatusBadge} from '../profile/ApplicationStatusBadge';
import {ApplicationCategoryBadge} from '../profile/ApplicationCategoryBadge';

export const columns = [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: Application) => <NavLink to={`/applications/${item.id}`}>{item.name}</NavLink>,
    },
    {
        title: I18n.get('URL'),
        width: '1fr',
        render: (item: Application) => item.url,
    },
    {
        title: I18n.get('Category'),
        width: '1fr',
        render: (item: Application) => <ApplicationCategoryBadge record={item}/>,
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: Application) => <ApplicationStatusBadge record={item}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Application) => formatTimestamp(item.created as string),
    },
];
